import { makeServicesTypesFromEnum } from '@/core/container/makeServicesTypes'

export enum NPS_SURVEY_SERVICES {
  NpsSurveyService,
  NpsSurveyRepository,
  NpsSurveyCommentFormService,
}

export type NpsSurveyServices = keyof typeof NPS_SURVEY_SERVICES

export const NPS_SURVEY_SERVICE_TYPES = makeServicesTypesFromEnum<NpsSurveyServices>(NPS_SURVEY_SERVICES)
